export interface Folder {
    folder_id: number;
    name: string;
    check_settings: CheckSettingsOutput;
}

export interface CheckSettingsOutput {
    is_check_date_required_on_publication: boolean;
    can_change_check_date_on_publication: boolean;
    append_to_new_date_unit: Period;
    append_to_new_date_value: number;
}

export enum Period {
    days = "days",
    weeks = "weeks",
    months = "months",
    years = "years"
}

export interface FolderMini {
    folder_id: number;
    folder_name: string;
    full_path: string;
}
